<template>
  <v-app data-testid="financialstatement-preparation">
      <v-card class="" elevation="2" data-testid="financialstatement-preparation__main-card">
        <v-card-title data-testid="financialstatement-preparation__header-bar">
          <h3 class="font-weight-medium" data-testid="financialstatement-preparation__header-title">Financial Statement Preparation</h3>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text data-testid="financialstatement-preparation__main-content">
          <v-tabs v-model="tab" background-color="white" class="elevation-1" data-testid="financialstatement-preparation__tabs">
            <v-tab class="pa-4" data-testid="financialstatement-preparation__tab-sharepoint">SharePoint</v-tab>
            <v-tab class="pa-4" data-testid="financialstatement-preparation__tab-manual-upload">Manual Upload</v-tab>
          </v-tabs>
          <p v-if="loadingMessage" style="color: red" data-testid="financialstatement-preparation__error-alert">{{loadingMessage}}</p>
          <v-tabs-items v-model="tab" class="mt-4" data-testid="financialstatement-preparation__tab-panels">
            <v-tab-item data-testid="financialstatement-preparation__tab-panel-sharepoint">
              <!-- SharePoint Specific Controls -->
              <v-btn @click="updateSharePointFS" color="secondaryBtn" class="mr-2" data-testid="financialstatement-preparation__update-sharepoint-btn"><span>Update SharePoint FS</span></v-btn>
              <v-btn @click="carryForwardSharePointFS" color="secondaryBtn" class="mr-2" data-testid="financialstatement-preparation__carryforward-sharepoint-btn"><span>Carry Forward SharePoint FS</span></v-btn>
              <v-btn @click="fetchFileListsharepoint" color="primary" data-testid="financialstatement-preparation__refresh-sharepoint-btn"><span>Refresh Sharepoint</span></v-btn>
              <v-data-table
                v-if="fileListsharepoint && fileListsharepoint.length > 0"  
                :headers="fileHeaderssharepoint"
                :items="fileListsharepoint"
                :search="search"
                :items-per-page="5"
                :sort-by="['createdDate']"
                :sort-desc="[true]"
                class="mt-4 Pl-table"
                :height="tableHeight"
                style="width: 100%;"
                data-testid="financialstatement-preparation__datatable-sharepoint"
              >
                <template v-slot:item="{ item, index }">
                  <tr class="tableHeaderBg" data-testid="financialstatement-preparation__row-sharepoint">
                    <td data-testid="financialstatement-preparation__cell-sharepoint-index">{{ index + 1 }}</td>
                    <td data-testid="financialstatement-preparation__cell-sharepoint-name">{{ item.name }}</td>
                    <td data-testid="financialstatement-preparation__cell-sharepoint-type">{{ item.type }}</td>
                    <td data-testid="financialstatement-preparation__cell-sharepoint-created-date">{{ item.createdDate }}</td>
                    <td data-testid="financialstatement-preparation__cell-sharepoint-created-by">{{ item.createdBy }}</td>
                    <td data-testid="financialstatement-preparation__cell-sharepoint-modified-date">{{ item.modifiedDate }}</td>
                    <td data-testid="financialstatement-preparation__cell-sharepoint-modified-by">{{ item.modifiedby }}</td>
                    <td data-testid="financialstatement-preparation__cell-sharepoint-size">{{ item.size }}</td>
                    <td>
                      <v-btn v-if="item.url" color="blue" @click="openFile(item.url)" data-testid="financialstatement-preparation__open-sharepoint-btn"><span>Open</span></v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <p v-else class="text-center mt-4" data-testid="financialstatement-preparation__empty-state-sharepoint">No files found.</p>
            </v-tab-item>
            <v-tab-item data-testid="financialstatement-preparation__tab-panel-manual-upload">
            <v-row data-testid="financialstatement-preparation__manual-upload-row">
              <v-col cols="12" data-testid="financialstatement-preparation__manual-upload-col-tabs">
                <v-btn @click="toggleSection('Standalone FS')" color="primary" class='mr-2' data-testid="financialstatement-preparation__standalone-btn"><span>Standalone</span></v-btn>
                <v-btn @click="toggleSection('Consolidation')" color="primary" class='mr-2' data-testid="financialstatement-preparation__consolidation-btn"><span>Consolidation</span></v-btn>
              </v-col>
              <v-col cols="12" v-if="section === 'Standalone FS'" data-testid="financialstatement-preparation__standalone-section">
                <v-file-input v-model="FSFiles" label="Upload FS Files" outlined dense multiple data-testid="financialstatement-preparation__standalone-fs-input"></v-file-input>
                <v-file-input v-model="TBFiles" label="Upload TB Files" outlined dense multiple data-testid="financialstatement-preparation__standalone-tb-input"></v-file-input>
                <v-file-input v-model="AEFiles" label="Upload AE Files" outlined dense multiple data-testid="financialstatement-preparation__standalone-ae-input"></v-file-input>
                <v-btn @click="updateFS" color="success" class="mr-2" :disabled="isLoading" data-testid="financialstatement-preparation__update-fs-btn"><span>Update FS</span></v-btn>
                <v-btn @click="carryForwardFS" color="success" :disabled="isLoading" data-testid="financialstatement-preparation__carryforward-fs-btn"><span>Carry Forward FS</span></v-btn>
              </v-col>
              <v-col cols="12" v-if="section === 'Consolidation'" data-testid="financialstatement-preparation__consolidation-section">
                <v-file-input v-model="SFSFiles" label="Upload SFS Files for Consolidation" outlined dense multiple data-testid="financialstatement-preparation__consolidation-sfs-input"></v-file-input>
                <v-file-input v-model="CFSFiles" label="Upload consolidated CFS" outlined dense multiple data-testid="financialstatement-preparation__consolidation-cfs-input"></v-file-input>
                <v-file-input v-model="CAEFiles" label="Upload Consolidation AE Files" outlined dense multiple data-testid="financialstatement-preparation__consolidation-cae-input"></v-file-input>
                <v-btn @click="startConsol" color="success" class='mr-2' :disabled="isLoading" data-testid="financialstatement-preparation__start-consol-btn"><span>Start Consolidation</span></v-btn>
                <v-btn @click="startConsolcarryforward" color="success" class='mr-2' :disabled="isLoading" data-testid="financialstatement-preparation__carryforward-consol-btn"><span>Carry Forward Consol FS</span></v-btn>
              </v-col>
              <v-col cols="12" data-testid="financialstatement-preparation__manual-upload-col-actions">
                <div class="d-flex justify-end">
                  <div>
                    <v-btn @click="downloadAllFiles" color="primary" data-testid="financialstatement-preparation__download-all-btn"><span>Download All Files</span></v-btn>
                    <span class="mx-2"></span>
                    <v-btn @click="fetchFileList" color="primary" data-testid="financialstatement-preparation__refresh-btn"><span>Refresh</span></v-btn>
                  </div>
                </div>
                <div class="d-flex justfy-between">
                    <!-- Search box on the left -->
                      <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search files"
                    single-line
                    hide-details
                    data-testid="financialstatement-preparation__search-input"
                  ></v-text-field>
                </div>
              </v-col>       
              <v-progress-linear
                v-if="isLoading"
                indeterminate
                color="primary"
                data-testid="financialstatement-preparation__loading-spinner"
              ></v-progress-linear>          
              <!-- S3 Files Table -->
              <v-data-table
                v-if="fileList && fileList.length > 0"
                :headers="fileHeaders"
                :items="fileList"
                :search="search"
                :items-per-page="5"
                :sort-by="['createdDate']"
                :sort-desc="[true]"
                class="mt-4 Pl-table"
                :height="tableHeight"
                style="width: 100%;"
                data-testid="financialstatement-preparation__datatable-s3"
              >
                <template v-slot:item="{ item, index }">
                  <tr data-testid="financialstatement-preparation__row-s3">
                    <td data-testid="financialstatement-preparation__cell-s3-index">{{ index + 1 }}</td>
                    <td data-testid="financialstatement-preparation__cell-s3-name">{{ item.name }}</td>
                    <td data-testid="financialstatement-preparation__cell-s3-type">{{ item.type }}</td>
                    <td data-testid="financialstatement-preparation__cell-s3-created-date">{{ item.createdDate }}</td>
                    <td data-testid="financialstatement-preparation__cell-s3-created-by">{{ item.createdBy }}</td>
                    <td>
                      <div class="d-flex align-center justify-center">
                        <v-tooltip bottom content-class="tooltip-bottom">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon small v-bind="attrs" v-on="on" @click="downloadFile(item.url)" class="pa-0 ma-0 action-btn" data-testid="financialstatement-preparation__download-btn">
                              <v-icon small>mdi-download</v-icon>
                            </v-btn>
                          </template>
                          <span>Download</span>
                        </v-tooltip>
                        <v-tooltip bottom content-class="tooltip-bottom">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn icon small v-bind="attrs" v-on="on" @click="deleteFile(item.name)" class="pa-0 ma-0 ml-1 action-btn" data-testid="financialstatement-preparation__delete-btn">
                              <v-icon small color="error">mdi-delete</v-icon>
                            </v-btn>
                          </template>
                          <span>Delete</span>
                        </v-tooltip>
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <p v-else class="text-center mt-4" data-testid="financialstatement-preparation__empty-state-s3">No files found.</p>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
          <v-dialog v-model="spreadsheetDialog" max-width="90%" data-testid="financialstatement-preparation__spreadsheet-dialog">
            <v-card>
              <v-card-title>
                <h4 class="font-weight-regular" data-testid="financialstatement-preparation__spreadsheet-title">Excel Viewer</h4>
                <v-spacer></v-spacer>
                <v-btn icon @click="spreadsheetDialog = false" data-testid="financialstatement-preparation__spreadsheet-close-btn"><v-icon>mdi-close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>
                <ejs-spreadsheet v-if="spreadsheetDialog" ref="spreadsheet" :openUrl="openUrl" :allowEditing="true" data-testid="financialstatement-preparation__spreadsheet"></ejs-spreadsheet>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveSpreadsheet" data-testid="financialstatement-preparation__spreadsheet-save-btn"><span>Save</span></v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-snackbar v-model="snackbar" :timeout="3000" data-testid="financialstatement-preparation__snackbar">{{ snackbarText }}</v-snackbar> 
        </v-card-text>
      </v-card>
  </v-app>
</template>

<script>
export default {  
  data() {
    return {
      section: '',
      clientId: '',
      FSFiles: [], 
      TBFiles: [], 
      AEFiles: [], 
      fileList: [],
      SFSFiles: [],
      CFSFiles: [],
      CAEFiles: [],
      tab: '',
      fileListsharepoint: [],
      isLoading: false,
      snackbar: false,
      snackbarText: '',
      search: '',
      spreadsheetDialog: false,
      selectedFile: null,
      openUrl: "",      
      fileHeaders: [
        { text: 'S.no', value: 'index', sortable: false, width: '80px' },
        { text: 'File name', value: 'name', width: '30%' },
        { text: 'Type', value: 'type', sortable: false, width: '15%' },
        { text: 'Created Date', value: 'createdDate', sortable: true, width: '20%' },
        { text: 'Created By', value: 'createdBy', width: '15%' },
        { text: 'Actions', value: 'actions', sortable: false, align: 'center', width: '120px' },
      ],
      fileHeaderssharepoint: [
        { text: 'S.no', value: 'index', sortable: false, width: '80px' },
        { text: 'File name', value: 'name' },
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Created Date', value: 'createdDate', sortable: true },
        { text: 'Created By', value: 'createdBy' },
        { text: 'Modified Date', value: 'modifiedDate' },
        { text: 'Modified By', value: 'modifiedby' },
        { text: 'Size', value: 'size' },
        { text: 'File Link', value: 'url', sortable: false, align: 'left' },
      ],
      tableHeight: '500px',
    };
  },
  mounted() {
    this.clientId = this.$store.state.client;
    this.fetchFileList();
    this.fetchFileListsharepoint();
  },
  methods: {
    updateSharePointFS() {
    this.isLoading = true;

    const requestData = {
    func: 'sfsupdatefs',
    clientId: this.clientId // Ensure this.clientDetails is defined
    };

    this.axios.post("/v2/financialclose/masters/financialstatement/updateSharePointFS", requestData)
    .then(() => {
      this.$toast.success('Financial statements updated successfully.');
    })
    .catch(error => {
      console.error("Failed to update financial statements:", error);
      this.$toast.error("Failed to update financial statements.");
    })
    .finally(() => {
      this.fetchFileListsharepoint(); // Ensure file list is fetched in all cases
      this.isLoading = false;
    });
    },
    carryForwardSharePointFS(){
    this.isLoading = true;
    const requestData = {
    func: 'sfscarryforwardfs',
    clientId: this.clientId // Ensure this.clientDetails is defined
    };

    this.axios.post("/v2/financialclose/masters/financialstatement/updateSharePointFS", requestData)
    .then(() => {
      this.$toast.success('Financial statements updated successfully.');
    })
    .catch(error => {
      console.error("Failed to update financial statements:", error);
      this.$toast.error("Failed to update financial statements.");
    })
    .finally(() => {
      this.fetchFileListsharepoint();
      this.isLoading = false;
    });
    },
    openFile(url) {
      if (url) {
        window.open(url, '_blank');
      } else {
        this.$toast.error("File not found.");
      }
    },
    toggleSection(selectedSection) {
      this.section = selectedSection;
    },
    createFormData(files) {
      let formData = new FormData();
      
      for (let key in files) {
        if (Array.isArray(files[key])) {  // Ensure it's an array before looping
          files[key].forEach(file => {
            formData.append(key, file);
          });
        }
      }
      
      formData.append('clientId', this.clientId);
      return formData;
    },
    formatDate(dateString) {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const date = new Date(dateString);
    const formattedDate = `${("0" + date.getDate()).slice(-2)}-${months[date.getMonth()]}-${date.getFullYear()}`;
    const time = date.toTimeString().split(' ')[0];  // Extracts the 'HH:MM:SS' format
    return `${formattedDate} ${time}`;
    },
    fetchFileList() {
      this.isLoading = true;
      this.$nova.apiGet.call(this, "/v2/financialclose/masters/financialstatement/files", { clientId: this.clientId })
        .then(response => {
          if (!response.data || !Array.isArray(response.data)) {
            console.error("Unexpected API response:", response.data);
            this.fileList = []; //  Prevents `undefined` issues
            return;
          }
          this.isLoading = false;
          this.fileList = response.data.map((file, index) => ({
            index: index + 1,
            name: file.name || "N/A",
            type: file.name.includes('Financial Statement') ? 'Output file' : 'Source file',
            createdDate: file.createdDate ? this.formatDate(file.createdDate) : "N/A",
            url: file.url || "",
          }));
        })
        .catch(error => {
          console.error('Error fetching files:', error);
          this.$toast.error("Failed to fetch files. Please try again.");
          this.fileList = []; //  Prevents further errors
          this.isLoading = false;
        });
    },
    downloadFile(url) {
      if(url){
        window.open(url, '_blank');
      } else {
        this.$toast.error("File not found.");
      }
    },
    deleteFile(fileName) {
      this.axios.post("/v2/financialclose/masters/financialstatement/deleteFile", {
          clientId: this.clientId,
          fileName: fileName
      })
      .then(response => {
          this.snackbarText = "File deleted successfully";
          this.snackbar = true;        
          console.log("File deleted:", response.data);
          this.fetchFileList();
      })
      .catch(error => {
          this.snackbarText = "Failed to delete file";
          this.snackbar = true;
          console.error("Error deleting file:", error);
      });
    },
    downloadAllFiles() {
      this.isLoading = true;

      this.$nova.apiGet.call(this, "/v2/financialclose/masters/financialstatement/downloadAll", { clientId: this.clientId }, { responseType: "blob" })
      .then(response => {
        
        // Create a Blob from the response
        const blob = new Blob([response.data], { type: "application/zip" });
        const link = document.createElement("a");

        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", "all_files.zip");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.fetchFileList();
        this.isLoading = false;
      })
      .catch(error => {
        console.error("Error downloading all files:", error);
        this.$toast.error("Error downloading files.");
        this.fetchFileList();
        this.isLoading = false;
      })
      .finally(() => {
        this.fetchFileList();
        this.isLoading = false;
      });
    },
    updateProgress(status) {
      this.loadingMessage = status;
      let loader = this.$loading.show({
        canCancel: false, // disables cancel button
        color: '#000',
        loader: 'dots'
      });
      return loader;
    },
    updateFS() {
      if (!this.FSFiles.length || (!this.TBFiles.length && !this.AEFiles.length)) {
        this.$toast.info('Please upload the necessary files.');
        return;
      }
      this.isLoading = true;
      const formData = this.createFormData({ FSFiles: this.FSFiles, TBFiles: this.TBFiles, AEFiles: this.AEFiles });
      formData.append('func', 'sfsupdatefs');
      this.axios.post("/v2/financialclose/masters/financialstatement/upload", formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(() => {
        this.$toast.success('Financial statements updated successfully.');
        this.fetchFileList();
        this.isLoading = false;
      }).catch(error => {
        console.error("Failed to update financial statements:", error);
        this.$toast.error("Failed to update financial statements.");
        this.fetchFileList();
        this.isLoading = false;
      }).finally(() => {
        this.fetchFileList();
        this.isLoading = false;
      });
    },
    carryForwardFS() {
      if (!this.FSFiles.length || (!this.TBFiles.length && !this.AEFiles.length)) {
        this.$toast.info('Please upload the necessary files.');
        return;
      }
      this.isLoading = true;
      const formData = this.createFormData({ FSFiles: this.FSFiles, TBFiles: this.TBFiles, AEFiles: this.AEFiles });
      formData.append('func', 'sfscarryforwardfs');
      this.axios.post("/v2/financialclose/masters/financialstatement/carryforward", formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(() => {
        this.$toast.success('Financial statements carried forward successfully.');
        this.fetchFileList();
        this.isLoading = false;
      }).catch(error => {
        console.error("Failed to carry forward financial statements:", error);
        this.$toast.error("Failed to carry forward financial statements.");
        this.fetchFileList();
        this.isLoading = false;
      }).
      finally(() => {
        this.fetchFileList();
        this.isLoading = false;
      });
    },
    async viewFile(url, fileName) {
    try {
        if (!fileName) {
            this.$toast.error("Invalid file name.");
            return;
        }

        const encodedFileName = encodeURIComponent(fileName);

        const response = await this.$nova.apiGet.call(this, `/v2/financialclose/masters/financialstatement/view-file/${this.clientId}/${encodedFileName}`);

        if (response.data.fileLink) {
            window.open(response.data.fileLink, "_blank");
        } else {
            this.$toast.error("Unable to generate file link.");
        }

    } catch (error) {
        console.error("Error in viewFile():", error.message || error);
        this.$toast.error("Error opening file. Please try again.");
    }
    },
    fetchFileListsharepoint() {
      this.tab = "sharepoint";
      this.isLoading = true;
      this.$nova.apiGet.call(this, `/v2/financialclose/masters/financialstatement/sharepointpick/`, { clientId: this.clientId })
        .then(response => {
          if (!response.data || !Array.isArray(response.data)) {
            console.error("Unexpected API response:", response.data);
            this.fileListsharepoint = []; //  Prevents `undefined` issues
            return;
          }

          this.isLoading = true;
          this.$set(this, 'fileListsharepoint', response.data.map((file, index) => ({
            index: index + 1,
            name: file.name || "N/A",
            type: file.name.includes('Financial Statement') ? 'Output file' : 'Source file',
            createdDate: file.createdDateTime ? this.formatDate(file.createdDateTime) : "N/A",
            createdBy: file.createdBy && file.createdBy.user ? file.createdBy.user.displayName : "N/A",
            modifiedDate: file.lastModifiedDateTime ? this.formatDate(file.lastModifiedDateTime) : "N/A",
            modifiedby: file.lastModifiedBy && file.lastModifiedBy.user ? file.lastModifiedBy.user.displayName: "N/A",
            size: file.size ? `${(file.size / 1024).toFixed(2)} KB` : "N/A",
            url: file.webUrl || "",
          })));
          this.isLoading = false;
        })
        .catch(error => {
          console.error('Error fetching files:', error);
          this.$toast.error("Failed to fetch files. Please try again.");
          this.fileListsharepoint = []; //  Prevents further errors
          this.isLoading = false;
        });
    },
    startConsol() {
      this.isLoading = true;
      const formData = this.createFormData({ CFSFiles: this.CFSFiles, SFSFiles: this.SFSFiles, CAEFiles: this.CAEFiles });
      formData.append('func', 'cfsupdatefs');
      this.axios.post('/v2/financialclose/masters/financialstatement/consolidate', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(() => {
        this.$toast.success('Consolidation process started successfully.');
        this.fetchFileList();
        this.isLoading = false;
      }).catch(error => {
        console.error("Failed to start consolidation:", error);
        this.$toast.error("Failed to start consolidation.");
        this.isLoading = false;
      }).
      finally(() => {
        this.isLoading = false;
      });
    },    
    startConsolcarryforward() {
      this.isLoading = true;
      const formData = this.createFormData({ CFSFiles: this.CFSFiles, SFSFiles: this.SFSFiles, CAEFiles: this.CAEFiles });
      formData.append('func', 'cfscarryforwardfs');
      this.axios.post('/v2/financialclose/masters/financialstatement/consolidate', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(() => {
        this.$toast.success('Consolidation process started successfully.');
        this.fetchFileList();
        this.isLoading = false;
      }).catch(error => {
        console.error("Failed to start consolidation:", error);
        this.$toast.error("Failed to start consolidation.");
        this.isLoading = false;
      }).
      finally(() => {
        this.isLoading = false;
      });
    }
  }
}
</script>

<style scoped>
body {
  min-height: 100vh;
  overflow-y: auto;
  box-shadow: none;
}
.v-card {
  overflow-y: auto;
  max-height: 90vh;
}

/* Optional: Styling the scrollbar for WebKit browsers */
.v-card::-webkit-scrollbar {
  width: 8px; /* Scrollbar width */
}

.v-card::-webkit-scrollbar-thumb {
  background-color: darkgrey; /* Scrollbar thumb color */
  border-radius: 4px;
}

.v-card::-webkit-scrollbar-track {
  background: #f1f1f1; /* Scrollbar track color */
}
.v-data-table {
  width: 90%;
  overflow-x: auto;
  border-radius: 12px;
  overflow: hidden;
}
.v-btn:not(.action-btn) { min-width: 150px; }
.v-card-title { align-items: center; }
.v-text-field { max-width: 400px; }
.header-actions-style {
  padding-left: 50%; /* Adjust as necessary */
}
::v-deep .v-data-table-header {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 5;
}

/* Curved borders for table */
::v-deep .v-data-table {
  border-radius: 12px;
  border: 1px solid var(--color-border-light);
}

::v-deep .v-data-table > .v-data-table__wrapper {
  border-radius: 12px;
}

/* Row styling - white background by default, grey on hover */
::v-deep .v-data-table tbody tr {
  background-color: var(--color-bg-white) !important;
}

::v-deep .v-data-table tbody tr:hover {
  background-color: var(--color-hover-bg) !important;
}

/* Better spacing for table cells */
::v-deep .v-data-table td {
  padding: 12px 16px !important;
}

::v-deep .v-data-table th {
  padding: 12px 16px !important;
}

/* Compact action column with minimal padding */
::v-deep .v-data-table td:last-child {
  padding: 8px !important;
}

/* First column - increase left padding */
::v-deep .v-data-table td:first-child,
::v-deep .v-data-table th:first-child {
  padding-left: 24px !important;
}

/* Last column - increase right padding */
::v-deep .v-data-table td:last-child,
::v-deep .v-data-table th:last-child {
  padding-right: 24px !important;
}

/* Remove extra padding from icon buttons */
::v-deep .v-btn.v-btn--icon.v-size--small {
  height: 28px !important;
  width: 28px !important;
}

/* Action buttons fixed width */
.v-btn.action-btn {
  width: 30px !important;
  min-width: 30px !important;
}
</style>
